import React from "react";

const Contact = () => {
  return (
    <section id="contact" className="container px-8 py-16 mx-auto">
      <h2 className="text-3xl font-bold text-center text-gray-900">Contact Us</h2>
      <p className="mt-4 text-lg text-center text-gray-700">
        Have questions? Get in touch with us today.
      </p>
      <form className="max-w-lg p-6 mx-auto mt-8 bg-white rounded-lg shadow-lg">
        <input type="text" placeholder="Your Name" className="w-full p-3 mb-4 border rounded-md" />
        <input type="email" placeholder="Your Email" className="w-full p-3 mb-4 border rounded-md" />
        <textarea placeholder="Your Message" className="w-full p-3 mb-4 border rounded-md"></textarea>
        <button className="w-full py-3 text-white bg-indigo-600 rounded-md hover:bg-indigo-700">Send Message</button>
      </form>
    </section>
  );
};

export default Contact;
